import "./PreparednessHub.module.css";
import Header from "@/reusable_sections/Header";
import Preparedness from "./sections/Preparedness";
import LatestGuidesTips from "./sections/LatestGuidesTips";
import JoinThePreparedCommunity from "./sections/JoinThePreparedCommunity";
import Footer from "@/reusable_sections/Footer";
export default function PreparednessHubPage() {
  return <div>
      <Header />
      <Preparedness />
      <LatestGuidesTips />
      <JoinThePreparedCommunity />
      <Footer />
    </div>;
}